module.exports = __webpack_public_path__ + "img/default-program-image.c09f7d0c.png";